const loaded = new Set<string>();

export function hasBeenLoaded(id: string | undefined): boolean {
	return id ? loaded.has(id) : false;
}

export function saveHasBeenLoaded(id: string | undefined): void {
	if (id) {
		loaded.add(id);
	}
}

export function cleanStateForTesting(): void {
	loaded.clear();
}
